export default __webpack_public_path__ + "static/media/Office04.19b1cf9e.jpg";